import React, { Component } from 'react';
import { Container, Grid } from 'semantic-ui-react';

import { connect } from 'react-redux';

import Banner from  '../../component/banner';
import FindPanelClinicsWidget from '../../component/widgets/find_panel_clinics';
import ECardWidget from '../../component/widgets/e_card';
import QuickLinksWidget from '../../component/widgets/quick_links';
import LatestHealthArticlesVideosWidget from '../../component/widgets/latest_health_articles_videos';
import ModalDialog from '../../component/widgets/modalDialog/ModalDialog';
import { setRemindUpdatePassword } from "../../actions";
// import RecentActivitiesWidget from '../../component/widgets/recent_activities';

class MainPage extends Component {
    render() {
        console.log(this.props);
        return (
            <Container fluid>
                <ModalDialog
                    open={this.props.appConfig.showRemindUpdatePassword}
                    title={<p>Update Password Reminder</p>} 
                    description={<p>Hi, it's been a while since you update your password.<br/>Do you want to update it now?</p>}
                    btnYesText="Update Password"
                    btnNoText="Skip"
                    btnYesAction={(function(){
                        this.props.setRemindUpdatePassword(false);
                        this.props.history.push('/app/profile?show=updatebio#SegmentUpdatePassword');
                    }).bind(this)}
                    btnNoAction={function(){
                        this.props.setRemindUpdatePassword(false);
                    }.bind(this)}
                />
                <Banner user={this.props.user} />
                <Grid style={{padding: 0}} columns={4}>
                    <Grid.Row>
                        <Grid.Column width={12}>
                            <Grid columns={1}>
                                <Grid.Column>
                                    <FindPanelClinicsWidget 
                                        clinicsTypeList={this.props.clinicsTypeList}
                                        history={this.props.history}
                                        configBenefit={this.props.configBenefit}
                                    />
                                </Grid.Column>
                                {this.props.configBenefit &&  this.props.configBenefit.featuresConfig &&
                                <Grid.Column width={12}>
                                    <QuickLinksWidget />
                                </Grid.Column>}
                                <Grid.Column width={4}>
                                    <ECardWidget configBenefit={this.props.configBenefit}/>
                                </Grid.Column>
                            </Grid>
                        </Grid.Column>
                        <Grid.Column width={4}>
                            <LatestHealthArticlesVideosWidget articleBannerList={this.props.articleBannerList}/>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Container>
        );
    }
}

function mapStateToProps(state) {
    return { 
        user: state.user.user,
        appConfig: state.appConfig,
        clinicsTypeList: state.clinics.typeList,
        articleBannerList: state.appConfig.articleBannerList,
        configBenefit: state.user.configBenefit,
    };
}

export default connect(mapStateToProps, {setRemindUpdatePassword})(MainPage);
/*
<Grid.Column>
    <RecentActivitiesWidget />
</Grid.Column>
*/
/**
import React, { Component } from 'react';
import { Container, Grid, Segment, Header, Divider, Label } from 'semantic-ui-react';

import ChartTopSubmission from '../../component/chart/top_submissions';
import ChartAccountSummary from '../../component/chart/account_summary';
import Banner from  '../../component/banner';

class MainPage extends Component {
    render() {
        return (
            <Container fluid>
                <Banner />
                <Grid style={{padding: 0}} columns={4}>
                    <Grid.Row>
                        <Grid.Column width={12}>
                            <Segment>
                                Account Summary
                                <Divider />
                                <Grid columns={2}>
                                    <Grid.Column>
                                        <p>
                                            Spending Summary
                                        </p>
                                        <ChartAccountSummary />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <p>
                                            Top 4 Claim Submission
                                        </p>
                                        <ChartTopSubmission />
                                    </Grid.Column>
                                </Grid>
                            </Segment>
                        </Grid.Column>
                        <Grid.Column>
                            <Segment
                                style={{
                                    background: 'linear-gradient(0deg,rgba(255,255,255,0.1),rgba(0,0,0,0.7)),url("https://theysaidso.com/img/bgs/man_on_the_mountain.jpg") no-repeat center center',
                                    
                                    padding: '50px 10px'
                                }}
                            >
                                <Header style={{color: '#FFF'}}>
                                    "Do not worry if you have built your castles in the air. They are where they should be. Now put the foundations under them."
                                </Header>
                                <Header.Subheader style={{color: '#FFF'}}>
                                    Henry David Thoreau
                                </Header.Subheader>
                            </Segment>
                        </Grid.Column>
                        <Grid.Column>
                            <Segment>
                                Claims Cut Off
                                <Divider />
                                <Header>
                                    6th Dec 2018, Thursday
                                </Header>
                                <Header.Subheader>
                                    21 days left
                                </Header.Subheader>
                            </Segment>
                        </Grid.Column>
                        <Grid.Column width={8}>
                            <Segment>
                                Last Claim Submission
                                <Divider />
                                Submitted 29 Aug 2018, Wednesday
                                <Header>
                                    ABC Clinic - Elliot, Li
                                </Header>
                                <Label style={{float: 'right'}}>
                                    $68.00
                                </Label>
                                <Header.Subheader>
                                    Flexibel Spending Account > Medical Expenses
                                </Header.Subheader>
                            </Segment>
                        </Grid.Column>
                        <Grid.Column>
                            <Segment
                                
                            >
                                Recent Activities
                                <Divider />
                            </Segment>
                        </Grid.Column>
                        <Grid.Column width={12}>
                            <Segment
                                
                            >
                                Recent Activities
                                <Divider />
                            </Segment>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Container>
        );
    }
}

export default MainPage;
 */